import React from 'react';
import ReactDOM from 'react-dom';
import IconClose from '../svg/IconClose';

const Modal = ({ id, isShowing, hide, title, height, width = 595, style, children, ...props }) => {
    const overlayStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 1040,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.4)'
    };

    const wrapperStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 1050,
        width: '100%',
        height: '100%',
        overflowX: 'hidden',
        overflowY: 'auto',
        outline: 0
    };

    const bodyStyle = {
        position: 'fixed',
        boxSizing: 'border-box',
        height: height,
        width: width,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
        padding: '24px 23px 40px',
        borderRadius: 15,
        backgroundColor: '#FFFFFF',
        boxShadow: '3px 2px 11px 0 rgba(0,0,0,0.33)',
        fontFamily: 'Roboto',
        fontSize: 22,
        fontWeight: 500,
        wordBreak: 'break-word',
        ...style
    };

    const headerStyle = {
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%'
    };

    return isShowing
        ? ReactDOM.createPortal(
              <React.Fragment>
                  <div id={id}>
                      <div style={overlayStyle} />
                      <div style={wrapperStyle} tabIndex={-1} role='dialog'>
                          <div style={bodyStyle} {...props}>
                              <div style={headerStyle}>
                                  {hide && (
                                      <IconClose
                                          id={`${id}-close`}
                                          size={19}
                                          data-dismiss='modal'
                                          onClick={hide}
                                      />
                                  )}
                              </div>
                              <div>{children}</div>
                          </div>
                      </div>
                  </div>
              </React.Fragment>,
              document.body
          )
        : null;
};

export default Modal;
